var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AssignmentItem } from "./AssignmentItem";
var AssignedAssessment = /** @class */ (function (_super) {
    __extends(AssignedAssessment, _super);
    function AssignedAssessment() {
        var _this = _super.call(this) || this;
        _this.uid = "";
        _this.Type = "Assessment";
        return _this;
    }
    Object.defineProperty(AssignedAssessment.prototype, "AssessmentId", {
        get: function () {
            return this.assessmentId;
        },
        set: function (v) {
            this.assessmentId = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssignedAssessment.prototype, "Uid", {
        get: function () {
            return this.uid;
        },
        set: function (v) {
            this.uid = v;
        },
        enumerable: true,
        configurable: true
    });
    return AssignedAssessment;
}(AssignmentItem));
export { AssignedAssessment };



// WEBPACK FOOTER //
// ./src/app/shared/models/AssignedAssessment.ts.pre-build-optimizer.js